import React from 'react';
import { Link } from 'react-router-dom';

const BULLETS = [
  'Solving mental health with data science — your everyday interactions become readable data, then readable insight.',
  'You don\'t have to "use it to fix yourself." Bloora is built to be fun to use; the work happens in the background.',
  'Optional bridge to a licensed professional, when and only when you choose it.',
];

export default function BlooraFeature() {
  return (
    <section className="py-24 md:py-32 px-6" style={{ backgroundColor: '#fbfcf3' }}>
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        {/* Visual */}
        <div className="order-2 lg:order-1">
          <div
            className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-gray-200 shadow-lg flex items-center justify-center"
            style={{
              background:
                'radial-gradient(circle at 30% 30%, rgba(128,0,128,0.10), transparent 60%), linear-gradient(135deg, #f5f6ed 0%, #fbfcf3 100%)',
            }}
          >
            <img
              src="/Bloora_logo2.png"
              alt="Bloora"
              className="w-3/4 max-w-[420px] h-auto drop-shadow-md"
            />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-xs uppercase tracking-widest text-gray-600">
              <span>Bloora</span>
              <span className="px-2 py-1 border border-gray-400">Now in early access</span>
            </div>
          </div>
        </div>

        {/* Copy */}
        <div className="order-1 lg:order-2">
          <span className="text-xs uppercase tracking-[0.3em] text-gray-500">
            Introducing Our Product
          </span>
          <h2 className="text-4xl md:text-5xl font-light mt-4 mb-4">Bloora</h2>
          <p className="text-lg text-gray-500 italic mb-6">
            Turning raw emotion into readable data.
          </p>
          <div className="w-20 h-px bg-gray-900 mb-8" />

          <p className="text-lg text-gray-700 leading-relaxed mb-8">
            Bloora turns your entire personality — your moods, your conversations,
            your patterns — into clear, readable insight. You get clarity, you know
            yourself more than ever, and you decide what to work on next.
          </p>

          <ul className="space-y-4 mb-10">
            {BULLETS.map((b) => (
              <li key={b} className="flex items-start text-gray-700 leading-relaxed">
                <span className="mt-2 mr-3 w-2 h-px bg-gray-900 flex-shrink-0" />
                <span>{b}</span>
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap gap-4">
            <Link to="/bloora" className="btn-primary">
              Explore Bloora
            </Link>
            <Link to="/early-access" className="btn-ghost">
              Join early access
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
